/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m22.85 16.1963244c.553 0 1 .448 1 1v11.199c0 .553-.447 1-1 1h-13.065c-.552 0-1-.447-1-1v-11.199c0-.552.448-1 1-1h3.733 5.599zm-1 11.199v-9.198h-1.733v4.598c0 .553-.448 1-1 1h-5.599c-.552 0-1-.447-1-1v-4.598h-1.733v9.198zm-7.332-5.599h3.599v-3.599h-3.599zm15.633-14.47599998c.408.136.683.518.683.949v3.04899998c0 .553-.447 1-1 1h-1.439v16.077c0 .553-.447 1-1 1s-1-.447-1-1v-16.077h-19.955v16.077c0 .553-.448 1-1 1s-1-.447-1-1v-16.077h-1.44c-.552 0-1-.447-1-1v-3.04899998c0-.44.288-.829.709-.957l14.028-4.269c.198-.06.41-.058.607.008zm-1.317 2.99799998v-1.32899998l-11.82-3.94-13.014 3.96v1.30899998z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;